module.exports = __webpack_public_path__ + "static/img/artistic-e.0587dd04.png";